var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(("width: " + _vm.width + "px;max-height: " + _vm.maxHeight + "px; vertical-align:middle; ")),attrs:{"src":("/clubs/" + (_vm.name.toLowerCase().replace(/\s/g, '')) + ".svg"),"alt":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }